import { FilterData } from "features/History/Filter/FilterData";
import { FilterActionChips } from "features/History/Filter/FilterActionChips";
import { FilterDropdowns } from "features/History/Filter/FilterDropdowns";
import { ResponsiveHStack } from "features/History/utils/HistoryCustomTableStyle";
import { calendarDateToday } from "features/VehicleSidebar/VehicleList/AddVehicles/VehicleList";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  DropsDatePicker,
  Field,
  HStack,
  SearchInput,
  VStack,
} from "shared/components/Spor";

type FilterProps = {
  filter: FilterData;
  setFilter: (filter: FilterData) => void;
};

export const Filter = ({ filter, setFilter }: FilterProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    // Remove train series from filter that are no longer in the allTrainIds (e.g. due to date change)
    setFilter(filter.cleanUpTrainIds());
  }, [filter.allTrainIds, setFilter]);

  return (
    <VStack
      pt={7}
      pr={2}
      pb={4}
      pl={2}
      alignItems="start"
      gap={2}
      overflowX="auto"
    >
      <HStack>
        <SearchInput
          width="365px"
          label={t("Søk etter tognr., stasjon eller stikkord")}
          value={filter.searchString}
          onChange={(e) => setFilter(filter.updateSearchString(e.target.value))}
        />
        <Field width="auto">
          <DropsDatePicker
            label={t("Dato")}
            variant="core"
            value={filter.date}
            onValueChange={(value) =>
              setFilter(filter.updateDate(value ?? calendarDateToday()))
            }
            withPortal
          />
        </Field>
      </HStack>
      <ResponsiveHStack gap={2}>
        <FilterActionChips filter={filter} setFilter={setFilter} />
        <FilterDropdowns filter={filter} setFilter={setFilter} />
      </ResponsiveHStack>
    </VStack>
  );
};
